import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { SlLogin } from "react-icons/sl";

function Home() {
    return (
        <div className="flex flex-row items-center justify-around">
            <div className='flex flex-col gap-5 items-stretch justify-center'>
                <div className="home__bg1 w-[100vh] h-[48vh] bg-cover bg-center mt-2"></div>
                <div className="home__bg2 w-[100vh] h-[48vh] bg-cover bg-center"></div>
            </div>
            <div className="w-[30%] flex flex-col gap-10 items-center justify-center">
                <h1 className="text-4xl font-bold">Welcome to Scriptwrite.ai</h1>
                <Link to={'/login'} className="text-white bg-green-500 hover:bg-green-700 rounded px-4 py-2 flex items-center">
                    Get Started
                    <SlLogin className='ml-2' />
                </Link>
            </div>
        </div>

    );
};

export default Home;
